import type { SVGProps } from 'react';

export const BatchesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="1" width="24" height="24" rx="4" fill="#E2E4E3" />
    <rect x="5" y="5" width="16" height="3" rx="1" fill="white" />
    <rect x="5" y="11" width="16" height="3" rx="1" fill="white" />
    <rect x="5" y="17" width="8" height="3" rx="1" fill="white" />
    <path
      d="M17 24C17 27.866 20.134 31 24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17H17V24Z"
      fill="#8F8FFF"
    />
    <path
      d="M27.6 23.25H23.4V21L20.4 24L23.4 27V24.75H27.6V23.25Z"
      fill="white"
    />
  </svg>
);
